import React from "react";


export function NotFound(){
  return (
    <div>Страница не найдена</div>
    )
}